import { render } from "./good-detail.vue?vue&type=template&id=0076f510&scoped=true"
import script from "./good-detail.vue?vue&type=script&lang=js"
export * from "./good-detail.vue?vue&type=script&lang=js"

import "./good-detail.vue?vue&type=style&index=0&id=0076f510&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0076f510"

export default script